import script from "./DiscoverItems.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscoverItems.vue?vue&type=script&setup=true&lang=js"

import "./DiscoverItems.vue?vue&type=style&index=0&id=5d9107a7&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d9107a7"]])

export default __exports__